"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = InGameView;

var _react = _interopRequireWildcard(require("react"));

var _openFullscreen = _interopRequireDefault(require("../../../helpers/fullscreen/openFullscreen"));

var _environment = require("../../environment");

var _threeJs = require("../../threeJs");

var _common = require("../../common");

var _InGameViewModule = _interopRequireDefault(require("./InGameView.module.scss"));

var _character = _interopRequireDefault(require("../../../mocks/character"));

var _skill = _interopRequireDefault(require("../../../mocks/skill"));

var _assets = require("../../../assets");

var _WindowManager = _interopRequireDefault(require("../../windows/WindowManager/WindowManager"));

var _PromptWindow = _interopRequireDefault(require("../../windows/other/PromptWindow/PromptWindow"));

var _components = require("./components");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var panoramaFile = "".concat(_assets.ASSETS_PANORAMAS, "/rog-by-ice.jpg");
var mercSkills = [_skill.default, _skill.default];
var partyMembers = [_character.default, _character.default];
var isRaining = true;
var isSnowing = false;
var isMusicPlaying = true;
var systemMsg = "Dear adventurers: We are happy to announce that 2x event is now active till 31.12.2021 00:00:00 CEST. Characters will receive 2x EXP, 2x loot money and 2x drop rate. Have fun!";
var skillBar1 = [_skill.default, _skill.default, _skill.default, undefined, _skill.default];
var skillBar2 = [];
var skillBar3 = [undefined, undefined, _skill.default, undefined, _skill.default];
var skillbars = [skillBar1, skillBar2, skillBar3];

function InGameView() {
  var _useState = (0, _react.useState)(true),
      _useState2 = _slicedToArray(_useState, 2),
      isModalVisible = _useState2[0],
      setIsModalVisible = _useState2[1];

  var renderFullscreenModal = (0, _react.useCallback)(function () {
    return /*#__PURE__*/_react.default.createElement(_common.Modal, {
      closeFunc: function closeFunc() {
        return setIsModalVisible(false);
      }
    }, /*#__PURE__*/_react.default.createElement(_PromptWindow.default, {
      onSubmit: function onSubmit() {
        (0, _openFullscreen.default)().catch(function (error) {
          return console.error(error);
        });
        setIsModalVisible(false);
      },
      onCancel: function onCancel() {
        return setIsModalVisible(false);
      }
    }, "Open Fullscreen ?"));
  }, []);
  return /*#__PURE__*/_react.default.createElement(_common.DefaultThemeWrapper, null, /*#__PURE__*/_react.default.createElement(_components.HotKeyContext, null, /*#__PURE__*/_react.default.createElement("div", {
    className: _InGameViewModule.default.inGameView
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _InGameViewModule.default.background
  }, /*#__PURE__*/_react.default.createElement(_threeJs.ThreePanorama, {
    panoramaFile: panoramaFile,
    isAutoRotating: true
  })), isModalVisible && renderFullscreenModal(), isMusicPlaying && /*#__PURE__*/_react.default.createElement(_environment.BackgroundMusic, {
    volume: 40
  }), isRaining && /*#__PURE__*/_react.default.createElement(_environment.RainAnimation, null), isSnowing && /*#__PURE__*/_react.default.createElement(_environment.SnowAnimation, {
    snowflakeCount: 500,
    speed: [5, 10],
    wind: [5, 30]
  }), /*#__PURE__*/_react.default.createElement(_environment.EnvironmentSound, {
    rain: isRaining,
    thunder: isRaining,
    wind: isSnowing
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _InGameViewModule.default.uiElements
  }, /*#__PURE__*/_react.default.createElement(_components.StatusEffectsBar, {
    statusEffects: _character.default.statusEffects,
    className: _InGameViewModule.default.statusEffectsBar
  }), /*#__PURE__*/_react.default.createElement(_components.Target, {
    name: "Gray Wolf",
    grade: 6,
    hp: 42,
    hpMax: 100,
    className: _InGameViewModule.default.target
  }), systemMsg && /*#__PURE__*/_react.default.createElement(_components.SystemNotification, {
    content: systemMsg,
    className: _InGameViewModule.default.systemNotification
  }), /*#__PURE__*/_react.default.createElement(_components.Party, {
    viewType: "LEADER",
    name: "Valley Wolfes",
    level: 3,
    expBullCount: 4,
    members: partyMembers,
    className: _InGameViewModule.default.party
  }), /*#__PURE__*/_react.default.createElement(_components.Radar, {
    className: _InGameViewModule.default.radar
  }), /*#__PURE__*/_react.default.createElement(_components.WebMenu, {
    className: _InGameViewModule.default.webMenu
  }), /*#__PURE__*/_react.default.createElement(_components.Chat, {
    className: _InGameViewModule.default.chat
  }), /*#__PURE__*/_react.default.createElement(_components.PowerItemsShopBtn, {
    className: _InGameViewModule.default.powerItemsShopBtn
  }), /*#__PURE__*/_react.default.createElement(_components.MercMenu, {
    hp: 100,
    hpMax: 120,
    skills: mercSkills,
    className: _InGameViewModule.default.mercMenu
  }), /*#__PURE__*/_react.default.createElement(_components.MainMenu, {
    character: _character.default,
    skillBars: skillbars,
    className: _InGameViewModule.default.mainMenu
  })), /*#__PURE__*/_react.default.createElement(_WindowManager.default, null))));
}